export default __webpack_public_path__ + "static/media/18.90788179.png";